"use strict";

exports.__esModule = true;
exports.TimelineColumnField = TimelineColumnField;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function TimelineColumnField(props) {
  var value = props.value;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("ColumnField.label", "Column Field")
  }, /*#__PURE__*/_react["default"].createElement("span", null, value));
}